{
  "coins": [],
  "messages": [],
  "contracts": [],
  "blobs": [],
  "block_height": 0,
  "da_block_height": 0
}
